import {
  Button,
  useDisclosure,
  VStack,
  Flex,
  Icon,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { Inputs } from '../../../../types/Enums';
import { GbiCode } from '../../../../types/CompanyScanTypes';
import { getFlowsDataTestId } from '../../../../utils/testUtils';
import GbiCodeModal from './GbiCodeModal';
import GbiCodeTable from './GbiCodeTable';

interface Props {
  name?: string;
  value: GbiCode[];
  onChange: (gbiCodes: GbiCode[]) => void;
  isDisabled?: boolean;
}

const GbiCodeInput = ({ name, value = [], onChange, isDisabled }: Props) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOnRemove = (index: number) => {
    onChange(value.filter((_, _index) => _index !== index));
  };

  return (
    <VStack align="stretch" spacing="4">
      {isOpen && (
        <GbiCodeModal
          value={value}
          onChange={onChange}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
      <GbiCodeTable
        gbiCodes={value}
        onRemove={handleOnRemove}
        isDisabled={isDisabled}
      />
      <Flex justify="flex-end">
        <Button
          onClick={onOpen}
          leftIcon={<Icon name="GeneralActionsAdd" />}
          data-test-id={getFlowsDataTestId(
            Inputs.GOUDSE_SBI_CODE,
            name || '',
            'ADD-BUTTON',
          )}
          isDisabled={isDisabled}
        >
          {t('FLOWS_COMPANY-SCAN_GBI-INPUT_ADD-GBI')}
        </Button>
      </Flex>
    </VStack>
  );
};

export default GbiCodeInput;
